// @flow

import React, { type Node } from 'react';
import styled, { css } from 'styled-components';

import { HighlightBox, Padding } from '../../../../../../commons/atoms';

import chevronIconSrc from './chevron-icon.svg';


type Props = {
  children?: Node,
  active?: boolean,
};

export function InformationAccordionHeader({ active, children, ...rest }: Props): Node {
  return (
    <HighlightBox {...rest} outline bordered>
      <Padding value="1em" style={{ display: 'flex' }}>
        <Content>{children}</Content>
        <ChevronIcon turned={active} />
      </Padding>
    </HighlightBox>
  );
}

const Content = styled.div`
  flex: 1;
`;

const ChevronIcon = styled.i`
  ${({ turned }) => turned && css`
    transform: rotate(180deg);
  `};

  ::after {
    content: '';
    padding: 0.75em;

    background-color: transparent;
    background-image: url(${chevronIconSrc});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
`;
